const mutations = {
    setCurrentUnload(state,payload){
        state.currentUnloading = payload
    },

}

export default mutations

